import Vue from 'vue'
import Vuex from 'vuex'
import rooms from './modules/rooms'
import years from './modules/years'
import students from './modules/students'
import groups from './modules/groups'
import teachers from './modules/teachers'
import lessons from './modules/lessons'
import comments from './modules/comments'
import auth from './modules/auth'
import orders from './modules/orders'
import payments from './modules/payments'
import files from './modules/files'
import books from './modules/books'
import results from './modules/results'
import surprises from './modules/surprises'
import tasks from './modules/tasks'
import home from './modules/home'
import events from './modules/events'
import app from './modules/app'
import items from './modules/items'
import branches from './modules/branches'
import documents from './modules/documents'

Vue.use(Vuex)

export default new Vuex.Store({
  // state: {},
  // mutations: {},
  // actions: {},
  modules: {
    app,
    rooms,
    years,
    students,
    groups,
    teachers,
    lessons,
    comments,
    auth,
    orders,
    payments,
    files,
    books,
    results,
    surprises,
    tasks,
    home,
    events,
    items,
    branches,
    documents,
  },
})
